import React from "react";

import { cn } from "../../../common/u1/cn";
import { Button } from "../../../common/u1/Button";
import LottieAnimation from "../../SuccessAnimation";

/* Shown when finalize answers "PAID" — the invoice needed no card at all. */
export const PaymentSuccessDialog = ({ onContinue }) => (
  <div
    className={cn(
      "w-[min(92vw,420px)] rounded-[var(--radius-modal)] border border-[var(--line)]",
      "bg-white p-6 text-center"
    )}
  >
    <div className="flex justify-center">
      <LottieAnimation />
    </div>
    <h2 className="m-0 mt-2 text-[20px] font-bold text-[var(--ink)] font-sans">
      Payment successful
    </h2>
    <p className="m-0 mt-1.5 text-[13px] leading-[1.55] text-[var(--muted)] font-sans">
      Your purchase has been completed.
    </p>
    <Button variant="coralSolid" className="mt-5 w-full" onClick={onContinue}>
      Continue
    </Button>
  </div>
);

export default PaymentSuccessDialog;
